import {
    format,
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    startOfMonth,
    endOfMonth,
    startOfYear,
    endOfYear,
} from "date-fns";
import { ActionCadence } from "../../common/types/actions";
import {
    fullDateFullYearFormat,
    fullMonthlyDateFormat,
} from "../../common/helpers/date";

export const getActionCadenceHeader = (
    date: Date | null,
    cadence: ActionCadence | null,
): string => {
    if (!date || !cadence) {
        return "";
    }

    switch (cadence) {
        case ActionCadence.ANNUAL:
            return `${date.getFullYear()}`;
        case ActionCadence.MONTHLY:
            return format(date, fullMonthlyDateFormat);
        case ActionCadence.WEEKLY: {
            const start = startOfWeek(date);
            const end = endOfWeek(date);
            return `${format(start, fullDateFullYearFormat)} - ${format(end, fullDateFullYearFormat)}`;
        }
        default:
            return "";
    }
};

export const getActionDateRange = (
    date: Date | null,
    cadence: ActionCadence | null,
): { start: Date; end: Date } | null => {
    if (!date || !cadence) {
        return null;
    }

    let start: Date;
    let end: Date;

    switch (cadence) {
        case ActionCadence.WEEKLY:
            start = startOfWeek(date);
            end = endOfWeek(date);
            break;
        case ActionCadence.MONTHLY:
            start = startOfMonth(date);
            end = endOfMonth(date);
            break;
        case ActionCadence.ANNUAL:
            start = startOfYear(date);
            end = endOfYear(date);
            break;
        default:
            start = startOfDay(date);
            end = endOfDay(date);
    }

    return { start, end };
};
